var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
/** @jsx jsx */


import { Fragment, memo } from "react";
import { jsx } from "theme-ui";
var containerStyle = {
  overflow: "hidden",
  position: "relative"
};
var ribbonStyle = {
  fontWeight: "bold",
  left: "0",
  position: "absolute",
  textAlign: "center",
  top: "50px",
  transform: "rotate(-30deg)",
  transformOrigin: "top left",
  width: "108px",
  zIndex: 1,
  "::before": {
    backgroundColor: "inherit",
    content: '""',
    height: "100%",
    left: "-49%",
    position: "absolute",
    top: "0",
    width: "50%"
  },
  "::after": {
    backgroundColor: "inherit",
    content: '""',
    height: "100%",
    position: "absolute",
    right: "-149%",
    top: "0",
    width: "150%"
  }
};

var RibbonContainer = function RibbonContainer(_a) {
  var children = _a.children,
      text = _a.text,
      _b = _a.backgroundColor,
      backgroundColor = _b === void 0 ? "#F5DA00" : _b,
      _c = _a.color,
      color = _c === void 0 ? "#000000" : _c;

  if (!text) {
    return jsx(Fragment, null, children);
  }

  return jsx("div", {
    sx: containerStyle
  }, jsx("div", {
    sx: __assign(__assign({}, ribbonStyle), {
      backgroundColor: backgroundColor,
      color: color
    })
  }, text), children);
};

export default memo(RibbonContainer);